import React from "react"
import ChevronRightIcon from "mdi-react/ChevronRightIcon";

import Footer from "./Footer";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import CustomSkeleton from "./Skeleton";
const percentageChangeWords = (newValue, oldValue) => {
  if (oldValue === 0) return "--";
  const change = ((newValue - oldValue) / oldValue) * 100;
  const rounded = Math.round(change * 10) / 10;

  if (rounded === 0) return "no change";
  const direction = rounded > 0 ? "increase" : "decrease";
  return `${Math.abs(rounded)}% ${direction}`;
};

const PropertyTypePage = (props) => {
	const { name, title, type, reportData, searchTags, summarizeGeographies, priorYearPeriodName, currentPeriodName, customDate, color , AiResponse, user} = props;
	const { dateOptions, theme, style } = customDate;

	const hasLocation = searchTags && searchTags.length>0
	return (
	  <div className="report-container page-section video-script">

		<section className="report-section">
		  <h3 className="header-text heading-location editable video-title location">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
		  <div className="header-subtext__heading editable video-title report-name">{type.name}</div>
		  <div className="subtext-grid">
			<div className="header-inner-subtext__heading editable video-title subtitle">
			  {type.title}
			</div>
			<div>
			  <div >Date Range</div>
			  <div className="editable date-range">{priorYearPeriodName} vs. {currentPeriodName}</div>
			</div>
		  </div>
	  	  <hr/>
          <div className="hidden-data">
            <div className="contracts-signed">{validateNestedData(reportData, `facets.${type.key}.contract_signed.current_period.count`)  ? _formatNumber(reportData.facets[type.key].contract_signed.current_period.count) : "--"}
            </div>
            <div className="ppsf">{validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.ppsf.med`)  ? '$'+_formatNumber(reportData.facets[type.key].recorded_sold.current_period.ppsf.med) : "--"}
            </div>
            <div className="percent-change">{(validateNestedData(
              reportData,
              `facets.${type.key}.contract_signed.current_period.count`
            ) &&
            validateNestedData(
              reportData,
              `facets.${type.key}.contract_signed.prior_year_period.count`
            )
              ? percentageChangeWords(
                reportData.facets[type.key].contract_signed.current_period
                .count,
                reportData.facets[type.key].contract_signed.prior_year_period
                .count
              )
              : "0")}
            </div>
            <div className="ppsf-percent-change">{validateNestedData(
            reportData,
            `facets.${type.key}.recorded_sold.current_period.ppsf.med`
            ) && validateNestedData(
              reportData,
              `facets.${type.key}.recorded_sold.prior_year_period.ppsf.med`
            )
            ? percentageChangeWords(
              reportData.facets[type.key].recorded_sold.current_period
                .ppsf.med,
              reportData.facets[type.key].recorded_sold.prior_year_period
                .ppsf.med
              )
            : "0"}
            </div>
          </div>
		  <div className="">
			
			  
			  {AiResponse && AiResponse && AiResponse.video_script ? AiResponse.video_script.map((sentence, index) => {
				  return <div className="script-bubble"><div className="icon">
				  <ChevronRightIcon />
				  </div> <p className={`editable copy-script scene-${(index+1)}`}>{sentence}</p></div>
			  }) :<CustomSkeleton count={30}/>}
			
		  
			
		  </div>
		</section>
		<Footer />
	  </div>
	)
  }
  
  export default PropertyTypePage;
